module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-toggle"
  }, [(!_vm.toggle) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 50 27",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Plan-index",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "plans-page-analytics-and-filter-panel-open-lg",
      "transform": "translate(-1130.000000, -120.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(701.000000, 120.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-11",
      "transform": "translate(326.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "toggle",
      "transform": "translate(128.000000, 13.500000) rotate(-180.000000) translate(-128.000000, -13.500000) translate(103.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Float"
    }
  }, [_c('rect', {
    attrs: {
      "id": "White-Background",
      "fill": "#C4E6EC",
      "x": "0",
      "y": "7",
      "width": "49.3548387",
      "height": "14",
      "rx": "7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ui-toggle__circle",
    attrs: {
      "id": "Knob",
      "cx": "36.5625",
      "cy": "13.8125",
      "r": "12.9375"
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.toggle) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('circle', {
    attrs: {
      "id": "b",
      "cx": "29.25",
      "cy": "11.05",
      "r": "10.35"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "x": "-45.9%",
      "y": "-16.9%",
      "width": "191.8%",
      "height": "201.4%",
      "filterUnits": "objectBoundingBox",
      "id": "toggleA"
    }
  }, [_c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "3",
      "in": "shadowSpreadOuter1",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1.5",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter1",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter2"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2",
      "in": "shadowSpreadOuter2",
      "result": "shadowOffsetOuter2"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1",
      "in": "shadowOffsetOuter2",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter2",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
      "in": "shadowBlurOuter2",
      "result": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMorphology', {
    attrs: {
      "radius": ".5",
      "operator": "dilate",
      "in": "SourceAlpha",
      "result": "shadowSpreadOuter3"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "3",
      "in": "shadowSpreadOuter3",
      "result": "shadowOffsetOuter3"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": ".5",
      "in": "shadowOffsetOuter3",
      "result": "shadowBlurOuter3"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowBlurOuter3",
      "in2": "SourceAlpha",
      "operator": "out",
      "result": "shadowBlurOuter3"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0510643116 0",
      "in": "shadowBlurOuter3",
      "result": "shadowMatrixOuter3"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "fill": "#C4E6EC",
      "y": "5.6",
      "width": "39.484",
      "height": "11.2",
      "rx": "5.6"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ui-toggle__circle",
    attrs: {
      "stroke-opacity": ".1",
      "stroke": "#000",
      "stroke-width": ".5",
      "cx": "29.25",
      "cy": "11.05",
      "r": "10.6"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c5d5ffe","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui-toggle.vue
// module id = 231
// module chunks = 1